const jda = [
  {
    componentName: 'CheckpointSelector',
    order: 1,
    translationKey: 'extract.reports.storeExecutionPlanning.steps.checkpointSelector',
    statusSection: 'storeExecutions',
    statusSubSection: 'checkpointSelector',
  },
  {
    componentName: 'StoreAllocation',
    order: 2,
    translationKey: 'extract.reports.storeExecutionPlanning.steps.storeAllocation',
    statusSection: 'storeExecutions',
    statusSubSection: 'storeAllocation',
  },
  {
    componentName: 'PlanogramDefinition',
    order: 3,
    translationKey: 'extract.reports.storeExecutionPlanning.steps.planogramDefinition',
    statusSection: 'storeExecutions',
    statusSubSection: 'planogramDefinition',
  },
  {
    componentName: 'ReportJda',
    order: 4,
    translationKey: 'extract.reports.storeExecutionPlanning.steps.storeExecutionOutputs',
    statusSection: 'storeExecutions',
    statusSubSection: 'jda',
  },
];

export default { jda };
